import React from 'react';
import { Container, Breadcrumb, BreadcrumbItem } from 'reactstrap';

function CustomBreadcrumb({ items, onNavigate }) {
  return (
    <Container className="mb-3">
      <Breadcrumb>
        {items.map((item, index) => (
          <BreadcrumbItem
            key={index}
            active={index === items.length - 1}
            tag={index === items.length - 1 ? 'span' : 'a'}
            onClick={
              index < items.length - 1 ? () => onNavigate(item.path) : undefined
            }
            style={{ cursor: index < items.length - 1 ? 'pointer' : 'default' }}
          >
            {item.label}
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </Container>
  );
}

export default CustomBreadcrumb;
